import tokenName from 'const/session'
import { getAppSessionItem } from 'helpers/appSessionItem'

/**
 * Gets the auth access token stored in session storage.
 * @returns the access token string
 */
const getSessionAccessToken = (): string => getAppSessionItem(tokenName)

export default getSessionAccessToken
